import cn from 'classnames'

import styles from './styles.less'

export default function TruncatedCell({ children, className }) {
  return <div className={cn(className, styles.TruncatedCell)}>{children}</div>
}
